import { useState, useRef } from "react";

export default function Contact() {
  const [sent, setSent] = useState(false);
  const [errors, setErrors] = useState({});
  const refs = { name: useRef(null), email: useRef(null), msg: useRef(null) };

  function validate(form) {
    const next = {};
    const name = form.name.value.trim();
    const email = form.email.value.trim();
    const msg = form.msg.value.trim();
    if (!name) next.name = "Enter your name.";
    if (!email) next.email = "Enter your email address.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
      next.email = "Enter a valid email address, e.g. name@company.com.";
    if (!msg) next.msg = "Enter a message so we know how to help.";
    return next;
  }

  function onSubmit(e) {
    e.preventDefault();
    const next = validate(e.target);
    setErrors(next);
    const firstBad = ["name", "email", "msg"].find((k) => next[k]);
    if (firstBad) {
      refs[firstBad].current && refs[firstBad].current.focus();
      return;
    }
    // Stub — wire to https://api.daksfirst.com/contact/send-email in production
    setSent(true);
  }

  return (
    <>
      <section className="page-header">
        <div className="wrap">
          <div className="eyebrow">Contact</div>
          <h1>Get in touch.</h1>
          <p className="sub">
            For investor enquiries, deal submissions, or general questions, send us a note —
            or contact a team member directly.
          </p>
        </div>
      </section>

      <section>
        <div className="wrap contact-grid">
          {sent ? (
            <div role="status" aria-live="polite">
              <h2 style={{ color: "var(--white)", marginBottom: 14 }}>Thanks — we'll be in touch.</h2>
              <p className="sub">A team member will respond within one business day.</p>
            </div>
          ) : (
            <form className="contact" onSubmit={onSubmit} noValidate>
              <div>
                <label htmlFor="name">Name</label>
                <input
                  id="name" name="name" type="text" ref={refs.name}
                  required aria-required="true"
                  aria-invalid={errors.name ? "true" : undefined}
                  aria-describedby={errors.name ? "name-error" : undefined}
                />
                {errors.name && (
                  <span id="name-error" className="field-error" role="alert">{errors.name}</span>
                )}
              </div>
              <div>
                <label htmlFor="email">Email</label>
                <input
                  id="email" name="email" type="email" ref={refs.email}
                  required aria-required="true"
                  aria-invalid={errors.email ? "true" : undefined}
                  aria-describedby={errors.email ? "email-error" : undefined}
                />
                {errors.email && (
                  <span id="email-error" className="field-error" role="alert">{errors.email}</span>
                )}
              </div>
              <div>
                <label htmlFor="org">Organisation (optional)</label>
                <input id="org" name="org" type="text" />
              </div>
              <div>
                <label htmlFor="msg">Message</label>
                <textarea
                  id="msg" name="msg" ref={refs.msg}
                  required aria-required="true"
                  aria-invalid={errors.msg ? "true" : undefined}
                  aria-describedby={errors.msg ? "msg-error" : undefined}
                ></textarea>
                {errors.msg && (
                  <span id="msg-error" className="field-error" role="alert">{errors.msg}</span>
                )}
              </div>
              <button className="btn btn-primary" type="submit" style={{ alignSelf: "flex-start" }}>
                Send enquiry
              </button>
            </form>
          )}

          <div>
            <div className="location-block">
              <h4>London</h4>
              <p className="addr">8 Hill Street<br />Mayfair, London W1J 5NG</p>
              <p className="meta">+44 20 7698 2709</p>
            </div>
            <div className="location-block">
              <h4>Mumbai</h4>
              <p className="addr">
                603, A Wing, Prathamesh Tower<br />
                Raghuwanshi Mills Compound<br />
                Senapati Bapat Marg<br />
                Lower Parel, Mumbai 400013
              </p>
              <p className="meta">+91 22 6212 0441</p>
            </div>
            <div className="location-block">
              <h4>Email</h4>
              <p className="addr"><a href="mailto:info@daksfirst.com">info@daksfirst.com</a></p>
            </div>
            <div className="location-block">
              <h4>LinkedIn</h4>
              <p className="addr">
                <a href="https://www.linkedin.com/company/daksfirst/" target="_blank" rel="noopener noreferrer">
                  linkedin.com/company/daksfirst →
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
